import { NipService } from 'src/app/_services/nip.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs/internal/Subscription';
import { MessService } from 'src/app/_services/mess-service.service';
import { NipFieldsService } from '../core/nip-fields.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-nip-all-improved',
  templateUrl: './nip-all-improved.component.html',
  styleUrls: ['./nip-all-improved.component.scss'],
  providers: [DatePipe, MessageService],
})
export class NipAllImprovedComponent implements OnInit, OnDestroy {
  nips: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };
  subscriptions: Subscription[] = [];
  loading = false;

  form: FormGroup;

  constructor(
    private nipsService: NipService,
    public fieldsService: NipFieldsService,
    private datePipe: DatePipe,
    private messService: MessService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthenticationService,
    private route: ActivatedRoute
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      batch: '',
      request_nr: '',
      deadline: '',
      product_name: '',
      product_code: '',
      complete: '',
    });

    this.route.queryParams.subscribe((params) => {
      console.log(params);

      const newDeadline = new Date(params.deadline);

      this.form.patchValue({
        batch: params?.batch ? params?.batch : '',
        request_nr: params?.request_nr ? params?.request_nr : '',
        deadline: params.deadline ? newDeadline : '',
        product_name: params?.product_name ? params?.product_name : '',
        product_code: params?.product_code ? params?.product_code : '',
        complete: params?.complete ? params?.complete : '',
      });
    });

    this.getAllNips();

    this.form.valueChanges.pipe(debounceTime(300)).subscribe((filters) => {
      if (filters !== null) {
        // Update URL with current form values
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: filters,
          queryParamsHandling: 'merge',
        });

        this.getAllNips(1, 10);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getAllNips(pageIndex = 1, perPage = 100) {
    this.loading = true;
    let form = this.form.getRawValue();

    if (form.deadline) {
      form.deadline = this.datePipe.transform(form.deadline, 'yyyy-MM-dd');
    }

    // if (form.created_at) {
    //   form.created_at = this.datePipe.transform(form.created_at, 'yyyy-MM-dd');
    // }
    const query = this.createQueryString(form);

    console.log(query);

    this.nipsService.getAllNips(pageIndex, perPage, query).subscribe({
      next: (responseData: any) => {
        this.nips.data = responseData.data.map((nip) => {
          return {
            ...nip,
            created_at: this.datePipe.transform(nip?.created_at, 'dd.MM.yyyy'),
            clientName: nip?.partner?.company,
            deadline: this.datePipe.transform(nip.deadline, 'dd.MM.yyyy'),
            productName: nip?.product_current?.name,
            currentStatus: nip?.status?.name,
            colorPriority: '',
            exportPdf: {
              type: 'buttons',
              elements: [
                {
                  tooltip: 'Kontrolni list - PDF',
                  icon: 'pi pi-file-pdf',
                  action: () => {
                    this.onExportControlSheetToPDF(nip);
                  },
                },
              ],
            },
            exportNip: {
              type: 'buttons',
              elements: [
                {
                  tooltip: 'NIP - PDF',
                  icon: 'pi pi-file-pdf',
                  action: () => {
                    this.onExportNipToPDF(nip);
                  },
                },
                // {
                //   tooltip: 'NIP - CSV',
                //   icon: 'pi pi-file-excel',
                //   action: () => {
                //     this.onExportNipToCsv(nip);
                //   },
                // },
              ],
            },
          };
        });

        this.nips.pagination = responseData.pagination;
        this.loading = false;
      },
      error: (err) => {
        if (err.status === 401) {
          this.authService.logout().subscribe(() => {
            this.router.navigate(['/login']);
          });
        }
      },
    });
  }

  onDelete(data: { event: Event; id: number }) {
    this.subscriptions.push(
      this.nipsService.delete(data.id).subscribe({
        next: (res: any) => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno',
            detail: 'Ušpesno ste obrisali stavku',
          });

          this.getAllNips();
        },
        error: (err) => {
          this.messService.add({
            severity: 'error',
            title: 'Greška',
            detail: 'Došlo je do greške',
          });
        },
      })
    );
  }

  onFilter() {
    const form = this.form.getRawValue();
  }
  /* ====================================
 *                HELPERS
 ======================================= */

  onPageChange(event: any) {
    this.getAllNips(event.page + 1, event.rows);
  }

  onResetFilter() {
    this.form.patchValue({
      batch: '',
      request_nr: '',
      deadline: '',
      product_name: '',
      product_code: '',
      created_at: '',
      complete: '',
    });

    // this.getAllNips();
  }

  createQueryString(form) {
    const query = new URLSearchParams(form).toString().replace('null', '');
    return query;
  }

  onExportNipToPDF(nipData) {
    this.subscriptions.push(
      this.nipsService.exportToPDF(nipData.id).subscribe((pdfHref) => {
        window.open(pdfHref.href, '_blank');
      })
    );
  }

  onExportNipToCsv(nipData) {
    this.subscriptions.push(
      this.nipsService.exportToCSV(nipData.id).subscribe((pdfHref) => {
        window.open(pdfHref.data, '_blank');
      })
    );
  }
  onExportControlSheetToPDF(nipData) {
    this.subscriptions.push(
      this.nipsService
        .exportControlSheetToPDF(nipData.id)
        .subscribe((pdfHref) => {
          window.open(pdfHref.href, '_blank');
        })
    );
  }
}
